import React from "react";

interface DealerDetailHeaderProps {
  handleGoBack: () => void;
}

export function DealerDetailHeader({ handleGoBack }: DealerDetailHeaderProps) {
  return (
    <div className="flex items-center mb-6">
      <button 
        onClick={handleGoBack}
        className="text-sm text-muted-foreground hover:text-foreground transition-colors"
      >
        ← Torna alla lista
      </button>
      <h1 className="text-2xl font-bold ml-4">Dettagli Compro Oro</h1>
    </div>
  );
}
